import { memo } from "react";
import FormTextField from "../FormTextField";

interface POIItemDetailImageProps {
    name: string;
}

function POIItemDetailImage({ name }: POIItemDetailImageProps) {
    return (
        <div>
            <FormTextField
                sx={{ mt: 1 }}
                fullWidth
                label="URL"
                variant="outlined"
                name={`${name}.url`}
            />
            <FormTextField
                sx={{ mt: 1 }}
                fullWidth
                label="Description"
                variant="outlined"
                name={`${name}.description`}
            />
        </div>
    );
}

export default memo(POIItemDetailImage);
